import React from 'react'
import { useNavigate } from 'react-router-dom'
import { IoChevronBack } from 'react-icons/io5'
import wavePng from '../components/ui/waves.png'

function FormLayout({ children, title, showBackButton = true }) {
  const navigate = useNavigate()

  return (
    <div className="min-h-screen bg-gray-50 relative">
      {/* Wave Background */}
      <div 
        className="absolute inset-0 w-full h-full bg-cover bg-no-repeat"
        style={{
          backgroundImage: `url(${wavePng})`,
          backgroundPosition: 'center top',
          zIndex: 0
        }}
      />

      {/* Content Container */}
      <div className="relative z-10 min-h-screen flex flex-col items-center justify-center px-4">
        {/* Form Card */}
        <div className="w-full" style={{ maxWidth: '663px' }}>
          {/* Header */}
          <div className="mb-6">
            {showBackButton && (
              <button
                onClick={() => navigate(-1)}
                className="flex items-center text-gray-900 mb-4 hover:text-gray-700 transition-colors"
              >
                <IoChevronBack size={24} />
                <span className="ml-1"></span>
              </button>
            )}
            <h1 className="text-2xl font-bold text-gray-900">{title}</h1>
          </div>

          {/* Form Container */}
          <div className="bg-white rounded-lg shadow-lg p-6">
            {children}
          </div>
        </div>
      </div>
    </div>
  )
}

export default FormLayout 